import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../services/auth/auth.service';
import { HrAuthServiceService } from '../../services/hr_auth/hr-auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService, 
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): boolean | UrlTree {
    // On server-side, allow navigation (will be checked again on client)
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    // On browser, check token directly from sessionStorage to avoid timing issues
    const token = sessionStorage.getItem('token');
    if (token) {
      return true;
    } else {
      return this.router.createUrlTree(['/login']);
    }
  }
}
 